import ActionType from "../actions/ActionType";
import { IAction } from "../actions/Action";
import { isEqual } from 'lodash/fp';
import { IProgressItem } from "../components/mike-topbar-progress-spinner";

export interface IProgressState {
 progressItems: IProgressItem[]
}

const initState = Array<IProgressItem>()

const addProgressItem = (state: IProgressItem[], action: IAction) => {
  const _state = [action.data, ...state]; 
  return _state;
};
const updateProgressItem = (state: IProgressItem[], action: IAction, ix: number) => {
  const eq = isEqual(state[ix], action.data)
  if (eq){
    return state
  }
  state[ix] = action.data; 
  return [...state];
};

const getMatchIx = (state: IProgressItem[], item: IProgressItem) => {
  let ix = -1;
  state.forEach((entry, i) => {
    if (entry.id === item.id) ix = i;
  });
  return ix;
};

const progressItems = (state = initState, action: IAction) => {  
 
  switch (action.type) {
      case ActionType.UPDATE_OR_ADD_PROGRESS_ITEM:   
      {
         const jx = getMatchIx(state, action.data);
        if (jx > -1) {
          return updateProgressItem(state, action, jx);
        } else {
          return addProgressItem(state, action);
        } 
      }    
    
      case ActionType.REMOVE_PROGRESS_ITEM:
        {
          const rmState = state.filter(item => {
          return item.id !== action.data.id;
        });         
        return [...rmState];
      }
    
        default:
          return state
  }
};

export default progressItems
